<template>

  <!-- Icons Gallery Block -->
  <page-block
    no-body
    v-if="hasContent"
    :bg-color="value.bgColor"
    class="icons-gallery-element"
    :text-color="value.textColor"
    :text-align="value.textAlign">

    <titled-text-element
      :value="value"
      :no-bottom="hasElements"/>

    <page-block
      v-if="hasElements">

      <swiper
        ref="swiper"
        v-if="hasElements"
        :options="swiperOptions"
        class="icons-gallery-element__swiper">

        <swiper-slide
          :key="element.id"
          v-for="element in value.elements"
          class="icons-gallery-element__slide">

          <icon-gallery-element
            :value="element"/>

        </swiper-slide>

        <!--
        <div
          slot="button-prev"
          class="swiper-button-prev"/>

        <div
          slot="button-next"
          class="swiper-button-next"/>
        -->

      </swiper>

    </page-block>

  </page-block>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';
  import PageBlockMixin from '@src/mixins/page-block-mixin';
  import TitledTextElement from '@src/components/element/titled-text-element';
  import IconGalleryElement from '@src/components/element/icon-gallery-element';

  export default {
    name: 'icons-gallery-element',
    mixins: [
      PageBlockMixin,
    ],
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    components: {
      PageBlock,
      TitledTextElement,
      IconGalleryElement,
    },
    data() {
      return {
        swiperOptions: {
          loop: true,
          delay: 2000,
          autoplay: true,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1125: {
              slidesPerView: 6,
              spaceBetween: 25,
            },
            820: {
              slidesPerView: 5,
              spaceBetween: 25,
            },
            625: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            400: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            320: {
              slidesPerView: 2,
              spaceBetween: 10,
            },
          },
        },
      };
    },
  };

</script>

<style lang="scss">

  .icons-gallery-element {
    color: inherit;

    &__swiper {
      margin-top: -$spacer-sm;
      position: relative;
    }

    .swiper-wrapper {
      align-items: center;
    }
  }

</style>
